import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

const getTemplateLayouts = async () => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`/layout/template`);
		const { layouts } = data;
		return layouts;
	} catch (error) {
		checkAuthError(error);
		console.log('error', error);
	}
};

export { getTemplateLayouts };
